import { t } from '@lingui/macro';
import {
    HeroBannerEntityType,
    HeroBannerContentType,
    Pack,
} from 'types/generated/graphql';

export const getFallbackByline = (
    entity?: HeroBannerEntityType,
    contentType?: HeroBannerContentType,
): string | undefined => {
    let byline: string;

    switch (contentType) {
        case 'Label':
            byline = t`Label`;
            break;
        case 'Collection':
            byline = t`Collection`;
            break;
        case 'Pack':
            byline = (entity as Pack)?.label?.name ?? '';
            break;
        default:
            byline = '';
            break;
    }

    return byline;
};
